"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemHref = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const menu_item_href_style_1 = __importDefault(require("./menu.item.href.style"));
class MenuItemHref extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, label, href, icon, suffix, selected, external } = this.props;
            const rootProps = {
                role: 'menuitem',
                className: classes.root
            };
            const linkProps = {
                href,
                'data-is-selected': selected,
                className: classes.link
            };
            if (external) {
                linkProps.rel = 'external';
                linkProps.target = '_blank';
            }
            return (jsx_runtime_1.jsx("li", Object.assign({}, rootProps, { children: jsx_runtime_1.jsxs("a", Object.assign({}, linkProps, { children: [icon && jsx_runtime_1.jsx("span", Object.assign({ className: classes.icon }, { children: icon }), void 0),
                        jsx_runtime_1.jsx("span", Object.assign({ className: classes.label }, { children: label }), void 0),
                        suffix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.suffix }, { children: suffix }), void 0)] }), void 0) }), void 0));
        };
    }
}
exports.MenuItemHref = MenuItemHref;
MenuItemHref.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    label: prop_types_1.default.string.isRequired,
    href: prop_types_1.default.string.isRequired,
    icon: prop_types_1.default.node,
    suffix: prop_types_1.default.node,
    selected: prop_types_1.default.bool,
    external: prop_types_1.default.bool
};
MenuItemHref.defaultProps = {
    icon: null,
    suffix: null,
    selected: false,
    external: false
};
exports.default = react_jss_1.default(menu_item_href_style_1.default)(MenuItemHref);
//# sourceMappingURL=menu.item.href.js.map